import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Container, Col } from "react-bootstrap";
import { processVariant } from "@utils";
import styled from "styled-components";
import {MgsLogoIcon} from "@components/ProductPage/ProductDetailSummary";
import MgsIcon from "/src/images/icons/mgs-logo.png";

const VariantSpan = styled.span`
  display: block;
  white-space: pre;
  font-size: 0.7rem;
`;

const CheckoutOrderItems: React.FC<IProps> = ({ subs }: IProps) => {
  return (
    <S.Wrapper>
      <S.CheckoutOrderItemsCard>
        <S.CheckoutOrderItemsCardHeader>
          <S.CheckoutOrderItemsCardHeaderTitle eventKey="0">
            Item(s) In Order
          </S.CheckoutOrderItemsCardHeaderTitle>
        </S.CheckoutOrderItemsCardHeader>
        <S.CheckoutorderitemsCardCollapse eventKey="0">
          <S.CheckoutOrderItemsCardBody>
            {subs.map((sub, i) => {
              return (
                <div key={i}>
                  <S.CheckoutOrderItemsSellerName>
                    {sub.seller.name}
                  </S.CheckoutOrderItemsSellerName>
                  <Container style={{ padding: "0" }}>
                    {sub.lines.map((line, j) => {
                      const variant = line?.variant;
                      const {
                        variantImageUrl,
                        variantImageAlt,
                        attributeImageUrl,
                        attributeImageAlt,
                        showVariants,
                        variantName,
                        productBrand,
                        productName,
                      } = processVariant(variant);
                      return (
                        <S.CheckoutOrderItemsProduct key={j}>
                          <Col xs={3}>
                            <img
                              src={variantImageUrl}
                              alt={variantImageAlt}
                              style={{ width: "100%" }}
                            />
                          </Col>
                          <Col xs={9}>
                            <S.CheckoutOrderItemsBrandName>
                              {productBrand}
                            </S.CheckoutOrderItemsBrandName>
                            <S.CheckoutOrderItemsProductName>
                              {productName}
                            </S.CheckoutOrderItemsProductName>
                            {showVariants && (
                              <VariantSpan>
                                <img
                                  src={attributeImageUrl}
                                  alt={attributeImageAlt}
                                  width={12}
                                />
                                {`  ${variantName}`}
                              </VariantSpan>
                            )}
                            <S.CheckoutOrderItemsQuantity>
                              Qty: {line?.quantity}
                            </S.CheckoutOrderItemsQuantity>
                            {
                              variant.product.productType.isMgs && (
                                <MgsLogoIcon
                                  src={MgsIcon}/>
                              )
                            }
                            {/* <S.CheckoutOrderItemsPrice>{getPrice(line.unitPrice.gross.amount, true)}</S.CheckoutOrderItemsPrice> */}
                          </Col>
                        </S.CheckoutOrderItemsProduct>
                      );
                    })}
                  </Container>
                </div>
              );
            })}
          </S.CheckoutOrderItemsCardBody>
        </S.CheckoutorderitemsCardCollapse>
      </S.CheckoutOrderItemsCard>
    </S.Wrapper>
  );
};

export { CheckoutOrderItems };
